import { useCallback } from 'react';
import apiClient from '../api/apiClient';

/**
 * Хук для отправки аналитических событий
 */
export const useAnalytics = () => {
    const trackEvent = useCallback((eventName, metadata = {}) => {
        apiClient.trackEvent(eventName, metadata);
    }, []);

    return { trackEvent };
};
